import { render, staticRenderFns } from "./cramp.vue?vue&type=template&id=3612b0b9&scoped=true&"
import script from "./cramp.vue?vue&type=script&lang=js&"
export * from "./cramp.vue?vue&type=script&lang=js&"
import style0 from "./cramp.vue?vue&type=style&index=0&id=3612b0b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3612b0b9",
  null
  
)

export default component.exports